import Axios from 'axios'
import { clearAuthentication, getAuthentication } from '../api/auth'

Axios.interceptors.request.use((config) => {
  if (!config.headers.Authorization) {
    const auth = getAuthentication()
    config.headers.Authorization = auth ? getAuthentication().token : ''
  }

  config.baseURL = process.env.REACT_APP_AWS_API_URL // 'http://localhost:3001/'
  // console.log(config)

  return config
})

Axios.interceptors.response.use(res => {
  //console.log(res.data);
  return res
})

export const handleApiError = (error) => {
  if (!error.response) {
    return
  }
  if (error.response.status) {
    const { status } = error.response
      
    if (status === 401 || status === 403 || status === 404) {
      clearAuthentication()
      return window.location.href = '/#/login'
    } else if (status >= 460 && status < 500) {
      //   dispatch(showError(error.response.data))
      // console.log(error.response.data)
    }
  }
}
